import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { ApplicantName } from 'src/app/models/state/pre-application.model';

@Component({
	selector: 'cmv-redirect-apps',
	templateUrl: './redirect-apps.component.html',
	styleUrls: ['./redirect-apps.component.scss'],
})
export class RedirectAppsComponent implements OnInit, OnDestroy {
	@Output() acceptedEvent: EventEmitter<void> = new EventEmitter();
	@Input() applicantName: ApplicantName;
	constructor() {}
	ngOnInit(): void {
		setTimeout(() => {
			document.body.style.overflow = 'hidden';
		}, 1000);
	}
	ngOnDestroy(): void {
		document.body.style.overflow = '';
	}

	onAccept(): void {
		this.acceptedEvent.emit();
	}
}
